import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Accordion from '@material-ui/core/Accordion';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import Typography from '@material-ui/core/Typography';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import IconButton from '@material-ui/core/IconButton';
import DeleteIcon from '@material-ui/icons/Delete';
import { Grid } from '@material-ui/core';
import { useEffect } from 'react'
import Tooltip from '@material-ui/core/Tooltip'; 

const useStyles = makeStyles((theme) => ({
    root: {
        width: '100%',
    },
    heading: {
        fontSize: theme.typography.pxToRem(16),
        // fontWeight: theme.typography.fontWeightRegular,
        fontWeight: 'bold', // Set to bold
        // textTransform: 'uppercase', // Set to uppercase
        marginTop: "4px"
    },

    accordionRoot: {
        // border: '2px solid #e0e0e0',
        borderRadius: '15px',
        marginBottom: '16px',
    },
    // Customize the summary (the header) of the Accordion
    accordionSummary: {
        borderRadius: '8px',
        backgroundColor: '#5d6975',
        // borderBottom: '2px solid #e0e0e0',
        color: 'white'
    },
    // Customize the details (the body) of the Accordion
    accordionDetails: {
        padding: theme.spacing(3),
        backgroundColor: "#F8F8F8"
    },
}));

export default function BasicAccordion(props) {
    const { index, item } = props;

    const classes = useStyles();

    const [expanded, setExpanded] = React.useState(false);

    const handleChange = (panel) => (event, isExpanded) => {
        setExpanded(isExpanded ? panel : false);
    };
    // console.log('props------>', props)

    useEffect(() => {
        var paragraphElement = document.querySelectorAll('.MuiTypography-root.makeStyles-heading-163.MuiTypography-body1');

        paragraphElement.forEach(pElement => {
            pElement.style.flex = '1';
        })

    }, [])



    return (
        <div className={`${classes.root} ${props?.class}`}>
            <Accordion expanded={expanded === `panel${index + 1}`} onChange={handleChange(`panel${index + 1}`)} className={classes.accordionRoot}>
                <AccordionSummary
                    expandIcon={<ExpandMoreIcon style={{ color: "white" }} />}
                    aria-controls={`panel${index + 1}bh-content`}
                    id={`panel${index + 1}bh-header`}
                    className={classes.accordionSummary}
                    key={props.item.id}
                    style={{ display: 'flex', justifyContent: 'space-between' }}

                >   
                    {props.item.type == "string" && (
                       <Typography className={classes.heading} style={{ flex: 1 }}>Hyperlink - {props.item.defaultValue ? props.item.defaultValue : props.item.title}</Typography>
                    )}
                    {props.item.type != "string" && (
                        <Typography className={classes.heading} style={{ flex: 1 }}>Operation - {props.item.desc ? props.item.desc : props.item.title ? props.item.title : props.item.name}</Typography>
                    )}
                    <Tooltip title='Delete Action'>
                        <IconButton aria-label="Delete" onClick={props.onDelete} size={"small"} color={"secondary"}>
                            <DeleteIcon />
                        </IconButton>
                    </Tooltip>
                </AccordionSummary>
                <AccordionDetails key={props.item.id} className={classes.accordionDetails}>
                    <Grid container direction={"row"} spacing={2}>
                        {props.children}
                    </Grid>
                </AccordionDetails>
            </Accordion>


        </div>
    );

}
